import { render, staticRenderFns } from "./Hinweise.vue?vue&type=template&id=35046e05&scoped=true"
import script from "./Hinweise.vue?vue&type=script&lang=js"
export * from "./Hinweise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35046e05",
  null
  
)

export default component.exports